module.exports = __webpack_public_path__ + "img/a-bg.360b2a15.png";